import { Breadcrumb, Flex, Row, Space } from "antd";
import { MainLayout } from "components/layouts";
import PayrollTabMenu from "./PayrollTabMenu";

import styles from "../styles/Payroll.module.css";
import { useTranslation } from "react-i18next";

const PayrollSetting = ({
  getPage = () => { },
  handleMenuChange = () => { },
  selectedMenu = []
}) => {
  const { t } = useTranslation();

  const menuBreadcrumbMapping = {
    'employment-type-setup': t('payroll.employment_type_setup.header'),
    'income': t('income.header'),
    'deduction': t('deduction.header'),
    'welfare': t("welfare.header")
  }

  return (
    <MainLayout>
      <Flex vertical style={{ rowGap: 40 }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("configuration.header"), href: "" },
            { title: t("payroll_setting.header"), href: "" },
            { title: menuBreadcrumbMapping[selectedMenu] || null }
          ]} />
          <h2>{menuBreadcrumbMapping[selectedMenu] || t("payroll_setting.entity")}</h2>
        </Flex>
        <Space className={styles.container} size={24} direction="vertical">
          <PayrollTabMenu selectedKeys={selectedMenu} onChange={handleMenuChange} />
          <Row>
            {getPage()}
          </Row>
        </Space>
      </Flex>
    </MainLayout>
  );
};

export default PayrollSetting;
